import { useEffect, useState } from 'react';
import { GridFilterItem, useGridApiContext, useGridSelector, gridFilterModelSelector } from '@mui/x-data-grid-premium';
import { GridFilterOperatorType } from '../components';

export interface ColumnFilterHookParams {
    id?: number;
    columnField: string;
    operator?: GridFilterOperatorType;
}

interface ColumnFilterHook {
    onFilterChange: (value?: string) => void;
    filterValue: string;
}

export const useColumnFilterHook = <TFiled extends string = string>({ id, columnField, operator }: ColumnFilterHookParams): ColumnFilterHook => {
    const apiRef = useGridApiContext();
    const filterModel = useGridSelector(apiRef, gridFilterModelSelector);
    const [filterValue, setFilterValue] = useState<string>('');
    const onChange = (value = '') => {
        setFilterValue(value);

        const filter: GridFilterItem = {
            id,
            field: columnField,
            value: value || '',
            operator: operator ?? 'contains',
        };

        apiRef.current.upsertFilterItem(filter);
    };

    useEffect(() => {
        const selectedNameFilter = filterModel?.items.find((item) => item.id === id);
        setFilterValue(selectedNameFilter?.value || '');
    }, [filterModel?.items]);

    return {
        filterValue,
        onFilterChange: onChange,
    };
};
